<template>
    <div>
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="2">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="22">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
                        <el-form-item label="发货日期">
                            <el-date-picker
                                    v-model="pickDate"
                                    type="daterange"
                                    align="right"
                                    unlink-panels
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    format="yyyy 年 MM 月 dd 日"
                                    value-format="yyyy-MM-dd"
                                    :picker-options="pickerOptions">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="formInline.status" filterable  placeholder="状态">
                                <el-option
                                        v-for="item in statusList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="渠道">
                            <el-select v-model="formInline.orderSource" filterable  placeholder="渠道">
                                <el-option
                                        v-for="item in orderSourceList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="卡类型">
                            <el-select v-model="formInline.cardType" filterable  placeholder="卡类型">
                                <el-option
                                        v-for="item in cardTypeList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item >
                            <el-button type="success" size="mini" @click="getCardPlan">查询</el-button>
                        </el-form-item>
                        <el-form-item >
                            <el-button type="success" size="mini" @click="downloadCardPlan">导出</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </div>

        <el-table :data="cardPlan" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading"
                  v-show="!showDialog">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column type="expand" label="展开看详情"  width="100">
                <template slot-scope="scope">
                    <el-form label-position="left"  class="demo-table-expand">
                        <el-form-item label="卡Id">
                            <span>{{ scope.row.cardId }}</span>
                        </el-form-item>
                        <el-form-item label="省">
                            <span>{{ scope.row.provinceName }}</span>
                        </el-form-item>
                        <el-form-item label="市">
                            <span>{{ scope.row.cityName }}</span>
                        </el-form-item>
                        <el-form-item label="区">
                            <span>{{ scope.row.areaName }}</span>
                        </el-form-item>
                        <el-form-item label="地址">
                            <span>{{ scope.row.address }}</span>
                        </el-form-item>
                        <el-form-item label="收件人">
                            <span>{{ scope.row.consigneeName }}</span>
                        </el-form-item>
                        <el-form-item label="电话">
                            <span>{{ scope.row.consigneePhone }}</span>
                        </el-form-item>
                        <el-form-item label="配送商品">
                            <span>{{ scope.row.promotionName }}</span>
                        </el-form-item>
                    </el-form>
                </template>
            </el-table-column>
            <el-table-column prop="orderMainNo" label="订单号" width="200">
                <template slot-scope="scope">
                    <a :href="getLink(scope.row.orderMainNo)" alt="点击查看卡订单" target="_blank">{{scope.row.orderMainNo}}</a>
                </template>
            </el-table-column>
            <el-table-column prop="cardOrderMainNo" label="卡订单号" width="200">
                <template slot-scope="scope">
                    <a :href="getLink(scope.row.cardOrderMainNo)" alt="点击查看卡订单" target="_blank">{{scope.row.cardOrderMainNo}}</a>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="发生时间" width="140"></el-table-column>
            <el-table-column prop="pickTime" :formatter="formatdate"  label="发货日期" width="90"></el-table-column>
            <el-table-column prop="statusName"   label="状态" width="80" ></el-table-column>
            <el-table-column prop="quantity" label="数量" width="60"></el-table-column>
            <el-table-column prop="orderSourceName" label="来源" ></el-table-column>
            <el-table-column prop="perPrice" label="价格" fixed="right"></el-table-column>
        </el-table>
        <div class="pagination-wrap" v-show="!showDialog">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
    </div>

</template>
<script>
    //导入 HTTP请求方法
    import {getPlanListApi,downCardPlanApi,getPrepayOrderSourceNameListApi} from '../../api/api';
    export default {
        data() {
            return {
                formInline: {
                    cardId:this.$route.query.cardId||'',
                    platformId: 1,
                    currentPage: 1,
                    cardType:0,
                    pageSize: 15,
                    recordsTotal: 0,
                    orderSource:0,
                    start:'',
                    end:'',
                    status:0
                },
                showDialog: false,
                loading: true,
                pickDate:[],
                orderSourceList:[],
                statusList:[{id:0,name:'全部'},{id:2,name:'待发货'},{id:3,name:'暂停'},{id:4,name:'配送中'},{id:5,name:'失效'},{id:6,name:'已完成'}],
                cardPlan: [],// 计划列表
                cardTypeList: [{id:0,name:'全部'},{id:1,name:'奶卡'},{id:2,name:'咖啡卡'}],// 卡类型
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                value1: '',
                value2: ''
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getCardPlan();
            this.getPrepayOrderSourceNameList();
        },
        methods: {
            getCardPlan(){
                this.loading = true;
                if(this.formInline.cardId!=''){
                    //this.formInline.status=0;
                }
                if(this.pickDate!=''&&this.pickDate!=null){
                    this.formInline.start=this.pickDate[0];
                    this.formInline.end=this.pickDate[1];
                }else {
                    this.formInline.start='';
                    this.formInline.end='';
                }
                getPlanListApi(this.formInline).then((res) => {
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.formInline.recordsTotal = res.data.value.total;
                        this.cardPlan = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            downloadCardPlan(){
                window.open(`${downCardPlanApi}?cardId=${this.formInline.cardId}&status=${this.formInline.status}&start=${this.formInline.start}&end=${this.formInline.end}&pageRouterUrl=prizelist`)

            },
            getPrepayOrderSourceNameList(){
                getPrepayOrderSourceNameListApi().then((res) => {
                    if (res.data.status == 200) {
                        this.orderSourceList = res.data.value;
                        this.orderSourceList.push({'id':0,'name':'所有渠道'});
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            getLink(orderMainNo){
                let returnUrl = ''
                returnUrl = `${window.location.origin}/#/queryorder?orderMainNo=${orderMainNo}`
                return returnUrl
            },
            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getCardPlan();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getCardPlan();
            },
            formatdate(row, column, cellValue){
                if(cellValue==null){
                   return cellValue;
                }
                return cellValue.split(" ")[0];
            },
            GetQueryString(name){
                let reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
                let sp = '?'
                let arr=window.location.href.split(sp);
                if(arr.length>=2){
                    let u=arr[1].substr(1);
                    u= u.replace(/amp;/g,"");
                    let r = u.match(reg);
                    if(r!=null)
                        return  decodeURIComponent(r[2]);
                }
                return(false);
            }
        },

    }
</script>
<style scoped>
    .order-main-num{
        text-decoration: underline;
    }
</style>


// WEBPACK FOOTER //
// src/views/order/cardOrderPlan.vue